module.exports = __webpack_public_path__ + "public/images/prizes/prize-uae-2.9398b3e311d592f680e965244b24ab2d.webp";